<template>
  <div id="app" >
    <div v-if="showAdminNav" style="display: flex;width: 100%">
      <admin-nav-bar ref="adminNavBar" v-if="login"></admin-nav-bar>
      <router-view></router-view>
    </div>
    <div v-if="showComponent" style="background-color: #efefef">
      <NavBar ref="NavBar" class="navInTop"></NavBar>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <WebBottom v-if="this.$store.state.showBottom"></WebBottom>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import adminNavBar from '@/components/adminNavBar'
import WebBottom from '@/components/WebBottom'
// import Quill from "quill";

export default {
  name: 'app',
  components: {
    NavBar,
    WebBottom,
    adminNavBar
  },
  watch: {
    '$route.path'(paht) {
      if (paht.includes('/admin')) {
        this.showComponent = false
        this.showAdminNav=true
        if(paht=='/admin/login'){
          this.login=false
        }else {
          this.login=true
        }
      }else {
        this.showComponent = true
        this.showAdminNav=false
      }
    }
  },
  data() {
    return {

      showComponent: true,
      showAdminNav:false,
      login:false
    }
  },
  mounted() {
    // 监听浏览器的popstate事件
    window.addEventListener('popstate', this.handlePopstate)
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听
    window.removeEventListener('popstate', this.handlePopstate)
  },
  methods: {
    setColor(path) {
      this.$refs.NavBar.setColor(path)
      // NavBar.methods.setColor(path)
    },
    handlePopstate(event) {
      // 当浏览器的历史记录发生变化时触发
      // event.state 包含了相关的历史状态信息
      window.location.reload()
      console.log('Browser history changed', event.state)
      // 在这里可以执行你的自定义回退操作
    }
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*color: #2c3e50;*/
  /*text-align: center;*/
  /* margin-top: 60px; */
}
.navInTop{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000; /* 保证导航栏在最上层 */
}
</style>
